import {makeStyles} from 'tss-react/mui'

export const useStyles = makeStyles()(() => ({
  inputMessageContainer: {
    borderRight: '1px solid #EAEDF0',
    borderTop: '1px solid #EAEDF0',
    borderBottom: '1px solid #EAEDF0',
    borderRadius: '4px',
    padding: '12px 16px',
    lineHeight: '16px',
    marginTop: '14px',
    boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.05)'
  },
  info: {
    borderLeft: '4px solid #016AD4',
    backgroundColor: '#F2F8FD'
  },
  warning: {
    borderLeft: '4px solid #EE8B00',
    backgroundColor: '#FFFFFF'
  },
  error: {
    borderLeft: '4px solid rgba(218, 9, 1, 1)',
    backgroundColor: '#FFFFFF'
  }
}))
